// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602271403/js/" + chunkId + "." + {"44":"8dcfcdce","225":"d873efe9","481":"bc6016e4","486":"c6f3a8fb","770":"f40a72fa"}[chunkId] + ".0.1364404388942153.chunk.js";
};